export enum EMenuButtonAction {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  COPY = 'COPY',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  //  Flow actions
  SETTINGS = 'SETTINGS',
  START = 'START',
  STOP = 'STOP',
}
